function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.331h512v341.326H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#496e2d",
  d: "M330.207 85.331H512v341.337H330.207z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 85.331h181.793v341.337H0z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  fill: "#ffda44"
}, /*#__PURE__*/React.createElement("path", {
  d: "M256 196.632c-32.785 0-59.362 26.577-59.362 59.362s26.577 59.362 59.362 59.362 59.362-26.577 59.362-59.362-26.577-59.362-59.362-59.362zm0 96.463c-20.491 0-37.101-16.611-37.101-37.101s16.61-37.101 37.101-37.101 37.101 16.61 37.101 37.101-16.61 37.101-37.101 37.101z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256 233.734c-8.196 0-14.84 6.644-14.84 14.84v22.261h29.682v-22.261c-.002-8.197-6.646-14.84-14.842-14.84z"
}));

const SvgAfghanistan = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAfghanistan, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/afghanistan.ab251339.svg";
export { ForwardRef as ReactComponent };